$(function(){
    SKILLZPAGES.init();
});
